/**
 * donation-form — currency formatting. SYNC: see ../_SYNC.md. Pure.
 *
 * Money is stored end-to-end in MINOR units (centimes); format via
 * Intl.NumberFormat on amountMinor / 100.
 */
/**
 * Format a minor-unit amount as a localized currency string.
 * @example formatMinor(2500, 'EUR', 'fr') // '25,00 €'
 */
export function formatMinor(amountMinor, currency, locale) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
    }).format(amountMinor / 100);
}
/**
 * The currency symbol for a currency/locale pair, derived from Intl (so the
 * custom-amount input does not need a hardcoded symbol). Falls back to the
 * currency code when no symbol part is produced.
 */
export function currencySymbol(currency, locale) {
    const parts = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
    }).formatToParts(0);
    return parts.find((p) => p.type === "currency")?.value ?? currency;
}
